"use strict";
/**
 * The design IR — a JSON scene graph that an LLM composes and two deterministic serializers
 * transcribe into `.svg` (Figma) and a single-slide `.pptx` (Canva).
 *
 * The model NEVER writes SVG or OOXML. Asking a model for OOXML produces files PowerPoint refuses to
 * open often enough to matter, and asking for SVG produces text that overflows its frame, because SVG
 * has no auto-wrap and a model cannot reliably compute line positions.
 *
 * TWO STATES, AND THEY ARE SEPARATE TYPES.
 *
 * The reference prototype hung a `_resolved` bag off each element in one mutable dict, which is the
 * failure the spec itself names first: once authored and resolved live in one object, every consumer
 * has to know which fields are trustworthy, and a serializer that reads the authored size instead of
 * the resolved one is a silent bug. Here {@link AuthoredText} has no line data and no way to acquire
 * it, {@link ResolvedText} has it and cannot be constructed without it, and both serializers accept
 * only {@link ResolvedDesign}. That is what guarantees the `.svg` and the `.pptx` contain identical
 * text with identical breaks: neither decides anything, they transcribe the same numbers.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DOWNSCALE_FRACTION = exports.CONTRAST_MIN_BODY = exports.CONTRAST_MIN_LARGE = exports.CONTRAST_LARGE_PX = exports.MIN_CLEARANCE_AT_1080 = exports.isAuthoredText = exports.isResolvedText = void 0;
const isResolvedText = (el) => el.type === 'text';
exports.isResolvedText = isResolvedText;
const isAuthoredText = (el) => el.type === 'text';
exports.isAuthoredText = isAuthoredText;
/**
 * Minimum clear space between text and a decorative element, at the 1080 reference, scaled by canvas.
 *
 * Absence of overlap is not enough: a headline 4px above an accent rule does not overlap it and reads
 * as though the last line is underlined.
 */
exports.MIN_CLEARANCE_AT_1080 = 16;
/** WCAG AA. Large text is the 3:1 tier; body is 4.5:1. */
exports.CONTRAST_LARGE_PX = 24;
exports.CONTRAST_MIN_LARGE = 3.0;
exports.CONTRAST_MIN_BODY = 4.5;
/**
 * How much shrinking is tolerable before the composition is simply wrong for the content.
 *
 * A note is not enough past this point: 8% is roughly the limit at which a headline still looks
 * deliberate, so beyond it the archetype is rejected and another is tried.
 */
exports.MAX_DOWNSCALE_FRACTION = 0.08;
//# sourceMappingURL=design-ir.js.map